import React, { useMemo, useState } from 'react';
import './usersAccess.css';
import UsersAccessOverview from './UsersAccessOverview';
import UsersAccessUsers from './UsersAccessUsers';
import UsersAccessRoles from './UsersAccessRoles';
import UsersAccessProjectAccess from './UsersAccessProjectAccess';
import UsersAccessConsultants from './UsersAccessConsultants';
import UsersAccessInvitations from './UsersAccessInvitations';
import AuditLogs from '../AuditLogs';

const TABS = [
  { key: 'overview', label: 'Overview' },
  { key: 'users', label: 'Users' },
  { key: 'roles', label: 'System Roles' },
  { key: 'project-access', label: 'Project Access' },
  { key: 'consultants', label: 'Consultant Directory' },
  { key: 'invitations', label: 'Invitations' },
  { key: 'audit', label: 'Audit Log' },
];

const UsersAccessShell = ({ initialTab = 'overview', canAccess }) => {
  const [tab, setTab] = useState(initialTab);
  const [filter, setFilter] = useState('');

  const onNavigate = (nextTab, nextFilter = '') => {
    setTab(nextTab);
    setFilter(nextFilter || '');
  };

  const body = useMemo(() => {
    switch (tab) {
      case 'overview':
        return <UsersAccessOverview onNavigate={onNavigate} />;
      case 'users':
        return <UsersAccessUsers initialFilter={filter} />;
      case 'roles':
        return <UsersAccessRoles initialMode={filter} />;
      case 'project-access':
        return <UsersAccessProjectAccess />;
      case 'consultants':
        return <UsersAccessConsultants initialMode={filter} />;
      case 'invitations':
        return <UsersAccessInvitations initialStatus={filter} />;
      case 'audit':
        return <AuditLogs />;
      default:
        return <UsersAccessOverview onNavigate={onNavigate} />;
    }
  }, [tab, filter]);

  if (!canAccess) {
    return <div className="empty-state"><h3>Access denied</h3><p>Admin Panel access is required.</p></div>;
  }

  return (
    <div className="ua-shell">
      <div className="section-header">
        <h2>Users &amp; Access</h2>
      </div>
      <div className="ua-tabs">
        {TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            className={`ua-tab ${tab === t.key ? 'is-active' : ''}`}
            onClick={() => { setTab(t.key); setFilter(''); }}
          >
            {t.label}
          </button>
        ))}
      </div>
      {body}
    </div>
  );
};

export default UsersAccessShell;
